import locales from './locales.json'

export const DEFAULT_LANGUAGE = locales.default
export const LANGUAGES = locales.languages
